/**
 * ★ Fase 43 — Registry dei FUNNEL VERTICALI (mirror frontend).
 * Source of truth backend: /app/backend/funnels.py — tenere allineati.
 *
 * Ogni funnel è fisso su lingua+mercato e NON mostra selettore lingua:
 * il link /f/<code> è già nella lingua giusta e crea lead nel CRM giusto.
 *
 * I testi hero qui sotto sono CONTENUTI PROVVISORI professionali:
 * verranno sostituiti con il materiale definitivo fornito dal cliente.
 */
import { BRAND } from './brand';

export const FUNNELS = {
  // ★ Fase 57 — FUNNEL IT: landing multi-paese dedicata (FunnelITAL.jsx,
  // route esplicita /f/it) — entry di mirror per coerenza col backend.
  it: {
    code: 'IT',
    language: 'it',
    marketLabel: 'Italia · Albania + Indonesia + Thailandia',
    heroImage: BRAND.heroSpille,
    heroTitle: 'Dal mattone al patrimonio',
    heroSubtitle:
      'Il percorso HCF Property: asset verificati on-site in Albania, Indonesia e Thailandia.',
    videoId: 'DEEz5eXicGU',
  },
  'it-al': {
    code: 'IT-AL',
    language: 'it',
    marketLabel: 'Albania',
    heroImage: BRAND.heroSpille,
    heroTitle: 'Investi nel Real Estate in Albania',
    heroSubtitle:
      'Appartamenti fronte mare sulla costa adriatica: progetti selezionati, verificati on-site e gestiti da HCF Property, con piani di pagamento agevolati.',
    videoId: 'DEEz5eXicGU', // Verification Pass · Albania
  },
  // ★ Fase 64 — landing dedicate Albania (AlbaniaAssetLanding.jsx, route esplicite)
  'it-al-na': {
    code: 'IT-AL-NA',
    language: 'it',
    marketLabel: 'Albania · Narea',
    heroImage: '/funnels/narea/narea-hero-wide.webp',
    heroTitle: 'Narea — Non stai comprando solo un immobile',
    heroSubtitle: 'Stai entrando in un\u2019infrastruttura patrimoniale.',
    videoId: 'DEEz5eXicGU',
  },
  'it-al-tg': {
    code: 'IT-AL-TG',
    language: 'it',
    marketLabel: 'Albania · Three Garden Qerret',
    heroImage: '/funnels/three-garden/tg-beach.webp',
    heroTitle: 'Three Garden Qerret — Non stai osservando solo un fronte mare',
    heroSubtitle: 'Stai entrando in un\u2019infrastruttura patrimoniale.',
    videoId: 'DEEz5eXicGU',
  },
  'it-lo': {
    code: 'IT-LO',
    language: 'it',
    marketLabel: 'Lombok · Indonesia',
    heroImage: BRAND.heroLombok,
    heroTitle: 'Green Paradise Lombok',
    heroSubtitle:
      'Ville e quote in gestione alberghiera a Bumbang Bay, Lombok: rendita da turismo internazionale in una delle destinazioni a più alta crescita dell’Indonesia.',
    videoId: 'V0Z643ZA4Pg', // Verification Pass · Indonesia
  },
  'it-ba': {
    code: 'IT-BA',
    language: 'it',
    marketLabel: 'Bali · Indonesia',
    // Foto reale Villa Bulan (Bali) — file locale (Fase 86)
    heroImage: '/funnels/indonesia/bali-villas/bali-hero.webp',
    heroTitle: 'Investi a Bali, Indonesia',
    heroSubtitle:
      'Ville turistiche operative nella destinazione più richiesta del Sud-Est asiatico: occupazione reale, gestione professionale e rendita in valuta forte.',
    videoId: 'V0Z643ZA4Pg', // Verification Pass · Indonesia
  },
  'es-id': {
    code: 'ES-ID',
    language: 'es',
    marketLabel: 'Indonesia',
    heroImage: BRAND.heroLombok,
    heroTitle: 'Invierte en Indonesia',
    heroSubtitle:
      'Villas turísticas operativas en Bali y Lombok: ocupación real, gestión profesional y rentabilidad en una de las economías de mayor crecimiento de Asia.',
    videoId: 'V0Z643ZA4Pg', // Verification Pass · Indonesia
  },
  'es-th': {
    code: 'ES-TH',
    language: 'es',
    marketLabel: 'Tailandia',
    // Hero Lux Harmony (Tailandia) — il drive-thumb heroChumphon non è embeddabile
    heroImage: '/funnels/thailand/lux-harmony/lh-hero-sunset.webp',
    heroTitle: 'Invierte en Tailandia',
    heroSubtitle:
      'Resorts y participaciones inmobiliarias en la costa oriental tailandesa: proyectos verificados on-site y gestionados por HCF Property.',
    videoId: null,
  },
  // ★ Fase 80 — landing dedicate Albania in SPAGNOLO (gemelle di it-al-na / it-al-tg)
  'es-al-na': {
    code: 'ES-AL-NA',
    language: 'es',
    marketLabel: 'Albania · Narea',
    heroImage: '/funnels/narea/narea-hero-wide.webp',
    heroTitle: 'Narea — No estás comprando solo un inmueble',
    heroSubtitle: 'Estás entrando en una infraestructura patrimonial.',
    videoId: 'DEEz5eXicGU',
  },
  'es-al-tg': {
    code: 'ES-AL-TG',
    language: 'es',
    marketLabel: 'Albania · Three Garden Qerret',
    heroImage: '/funnels/three-garden/tg-beach.webp',
    heroTitle: 'Three Garden Qerret — No partas del inmueble',
    heroSubtitle: 'Parte de la infraestructura patrimonial.',
    videoId: 'DEEz5eXicGU',
  },
  'en-id': {
    code: 'EN-ID',
    language: 'en',
    marketLabel: 'Indonesia',
    heroImage: BRAND.heroLombok,
    heroTitle: 'Invest in Indonesia',
    heroSubtitle:
      'Operating tourist villas in Bali and Lombok: real occupancy, professional management and returns in one of Asia’s fastest-growing economies.',
    videoId: 'V0Z643ZA4Pg', // Verification Pass · Indonesia
  },
  'en-al': {
    code: 'EN-AL',
    language: 'en',
    marketLabel: 'Albania',
    heroImage: BRAND.heroSpille,
    heroTitle: 'Invest in Albanian Real Estate',
    heroSubtitle:
      'Seafront apartments on the Adriatic coast: hand-picked projects, verified on-site and managed by HCF Property, with staged payment plans.',
    videoId: 'DEEz5eXicGU', // Verification Pass · Albania
  },
  // ★ Fase 85 — FUNNEL EN (gemello del Funnel ES in inglese) + landing dedicate
  'en': {
    code: 'EN',
    language: 'en',
    marketLabel: 'English · Albania + Indonesia + Thailand',
    heroImage: BRAND.heroSpille,
    heroTitle: 'From bricks to wealth',
    heroSubtitle: 'Verify territory, assets and live data before you invest.',
    videoId: 'DEEz5eXicGU',
  },
  'en-th': {
    code: 'EN-TH',
    language: 'en',
    marketLabel: 'Thailand',
    heroImage: '/funnels/thailand/lux-harmony/lh-hero-sunset.webp',
    heroTitle: 'Invest in Thailand',
    heroSubtitle:
      'Resorts and real-estate shares on Thailand’s eastern coast: projects verified on-site and managed by HCF Property.',
    videoId: null,
  },
  'en-ba': {
    code: 'EN-BA',
    language: 'en',
    marketLabel: 'Bali · Indonesia',
    heroImage: '/funnels/indonesia/bali-villas/bali-hero.webp',
    heroTitle: 'Villa Flora Bali',
    heroSubtitle: 'Private. Tropical. Essential.',
    videoId: 'V0Z643ZA4Pg',
  },
  'en-lo': {
    code: 'EN-LO',
    language: 'en',
    marketLabel: 'Lombok · Indonesia',
    heroImage: BRAND.heroLombok,
    heroTitle: 'Green Paradise Lombok',
    heroSubtitle: 'Luxury villas in Bumbang Bay: verify first, analyse, then choose the villa.',
    videoId: 'V0Z643ZA4Pg',
  },
  'en-al-na': {
    code: 'EN-AL-NA',
    language: 'en',
    marketLabel: 'Albania · Narea',
    heroImage: '/funnels/narea/narea-hero-wide.webp',
    heroTitle: 'Narea — You are not just buying a property',
    heroSubtitle: 'You are entering a wealth infrastructure.',
    videoId: 'DEEz5eXicGU',
  },
  'en-al-tg': {
    code: 'EN-AL-TG',
    language: 'en',
    marketLabel: 'Albania · Three Garden Qerret',
    heroImage: '/funnels/three-garden/tg-beach.webp',
    heroTitle: 'Three Garden Qerret — Don’t start from the property',
    heroSubtitle: 'Start from the wealth infrastructure.',
    videoId: 'DEEz5eXicGU',
  },
};

export function getFunnelClient(codeOrSlug) {
  if (!codeOrSlug) return null;
  const key = String(codeOrSlug).trim().toLowerCase();
  if (FUNNELS[key]) return { slug: key, ...FUNNELS[key] };
  const entry = Object.entries(FUNNELS).find(([, f]) => f.code === String(codeOrSlug).trim().toUpperCase());
  return entry ? { slug: entry[0], ...entry[1] } : null;
}
